export default {"src":"/_next/static/media/tescoma-klub-karta.3648cf7b.svg","height":63,"width":100,"blurWidth":0,"blurHeight":0};